import React, { useState } from "react";
import { Divider, Tabs, Select, Button } from "antd";
import { MenuOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { TAB_KEYS, TAB_ITEMS } from "./OutstandComponent/constants";
import { getYearOptions } from "./OutstandComponent/utils";
import MergeTab from "./OutstandComponent/MergeTab";
import BookTab from "./OutstandComponent/BookTab";
import ReconciledTab from "./OutstandComponent/ReconciledTab";
import OutstandingTab from "./OutstandComponent/OutstandingTab";

// 新增 tab：constants.js 加一项，这里加一行映射
const TAB_COMPONENTS = {
  [TAB_KEYS.MERGE]: (p) => <MergeTab {...p} />,
  [TAB_KEYS.CR]: (p) => <BookTab {...p} journalType="CR" />,
  [TAB_KEYS.CP]: (p) => <BookTab {...p} journalType="CP" />,
  [TAB_KEYS.MANUAL_RECONCILED]: (p) => <ReconciledTab {...p} clearType={1} />,
  [TAB_KEYS.AUTO_RECONCILED]: (p) => <ReconciledTab {...p} clearType={2} />,
  [TAB_KEYS.OUTSTANDING]: (p) => <OutstandingTab {...p} />,
};

export default function OutstandPage() {
  const [activeTab, setActiveTab] = useState(TAB_KEYS.MERGE);
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleRefresh = () => {
    if (loading) return;
    setRefreshKey((k) => k + 1);
  };

  const renderTab = TAB_COMPONENTS[activeTab];

  return (
    <div className="fund-transfer-page">
      <div className="fund-transfer-header">
        <div className="fund-transfer-header-title">
          <MenuOutlined />
          Outstanding Bank Reconciliation Transactions
        </div>
      </div>
      <Divider style={{ borderColor: "#E2E8F0", marginTop: 8, marginBottom: 16 }} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={TAB_ITEMS}
          style={{ marginBottom: 0 }}
        />
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Button icon={<ReloadOutlined spin={loading} />} onClick={handleRefresh}>
            Refresh
          </Button>
          <span style={{ fontSize: 14, color: "#000", fontWeight: 500 }}>Year:</span>
          <Select
            value={selectedYear}
            onChange={setSelectedYear}
            options={getYearOptions()}
            style={{ width: 120 }}
            placeholder="Select Year"
          />
        </div>
      </div>

      {/* key=activeTab：切 tab 强制卸载重建（CR/CP 共用 BookTab，没有 key 不会重新请求） */}
      {renderTab?.({
        key: activeTab,
        year: selectedYear,
        refreshKey,
        onLoadingChange: setLoading,
      })}
    </div>
  );
}